import { useEffect, useState } from "react";

/* -------- packages -------- */
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
  FormGroup,
  UncontrolledTooltip,
  Input,
  Spinner,
} from "reactstrap";
import Select from 'react-select';
import DatePicker from "react-datepicker";
  import { registerLocale, setDefaultLocale } from  "react-datepicker";
  import { fr } from 'date-fns/locale/fr';
  registerLocale('fr', fr)
  import "react-datepicker/dist/react-datepicker.css";
  import moment from "moment";
  import { set, setDate } from "date-fns";
/* -------- ------- -------- */

/* -------- components -------- */
import { avatarImages, chartColorsPallette, months } from '../../utils/items';
import TotalKpi from "../../components/ui/Charts&KPI/TotalKpi";
import { Link, useNavigate } from "react-router-dom";

import PieChart from "../../components/ui/Charts&KPI/PieChart";
import ColumnWithDataLabels from "../../components/ui/Charts&KPI/ColumnChart";
import SpineChart from "../../components/ui/Charts&KPI/SpineChart";
import DashboardLayout from "../../components/layout/Dashboard";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { fetchDashboardRequest } from "../../store/dashboard/actions";
import Loading from "../../components/ui/Loading";
import { dictionary } from "../../utils/dictionary";
import SpineAndColumnChart from "../../components/ui/Charts&KPI/SpineAndColumnChart";
import { checkConfigurationsExpiredRequest, fetchProjectsRequest, fetchUsersRequest } from "../../store/actions";
/* -------- ------- -------- */

export default function Dashboard () {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  

  const parameters = useSelector(state => state.Parameters);
  const user = useSelector(state => state.Login.user);
  const userPref = user && typeof user.prefs === 'object' ? user.prefs : JSON.parse(user.prefs);

  const dateNowMoment = moment(); // get current date from momment JS
  const dateFromMoment = dateNowMoment.clone().subtract(6, 'month'); // get 6 months ago date from moment JS
  
  document.title = `${t('home')} | ${parameters.appName}`; //meta title

  const projects = useSelector(state => state.Projects.projects); // get projects from store
  const {users} = useSelector(state => state.Users); // get users from store

  const { loadingDashboard, errorDashboard } = useSelector(state => state.Dashboard);
  const dashboardData = useSelector(state => state.Dashboard);

  const [customersNum, setCustomersNum] = useState(0);
  const [projectsNum, setProjectsNum] = useState(0);
  const [projectsOpen, setProjectsOpen] = useState(0);
  const [projectsClose, setProjectsClose] = useState(0);
  const [configsNum, setConfigsNum] = useState(0);
  const [confirmedConfigNum, setConfirmedConfigNum] = useState(0);
  const [inProgressConfigNum, setinProgressConfigNum] = useState(0);
  const [expiredConfigNum, setexpiredConfigNum] = useState(0);
  
  
  useEffect(() => { // count projects and configurations
    const totalProjects = projects.length;
    const totalProjectsOpen = projects.filter(project => project.status === 'OPENED').length;
    const totalProjectsClose = projects.filter(project => project.status === 'CLOSED').length;
    const totalConfigs = projects.reduce((acc, project) => acc + (project.ProjConfigurations?.length || 0), 0);
    const totalinProgress = projects.reduce((acc, project) => acc + (project.ProjConfigurations?.filter(config => config.status === 'PENDING')?.length || 0), 0);
    const totalConfirmed = projects.reduce((acc, project) => acc + (project.ProjConfigurations?.filter(config => config.status === 'QUOTE_OK')?.length || 0), 0);
    const totalinExpired = projects.reduce((acc, project) => acc + (project.ProjConfigurations?.filter(config => config.status === 'QUOTE_EXPIRED')?.length || 0), 0);
    
    setProjectsNum(totalProjects);
    setProjectsOpen(totalProjectsOpen);
    setProjectsClose(totalProjectsClose);
    setConfigsNum(totalConfigs);
    setConfirmedConfigNum(totalConfirmed);
    setinProgressConfigNum(totalinProgress);
    setexpiredConfigNum(totalinExpired);
  }, [projects]);

  useEffect(() => { // count projects and configurations
    const customers = users.filter(user => user.groupId == 3); 
    
    setCustomersNum(customers.length);
  }, [users]);
  
  const [imgSrc, setImgSrc] = useState("logoIcon");
  
  useEffect( () => {
    let currentImage;
    // Vérifier si la valeur a déjà une image associée
    if (user && userPref && userPref.profileImage) {
      currentImage =  avatarImages?.find((image) => image.id == userPref.profileImage);
    }
    setImgSrc((currentImage) ? currentImage.path : parameters.logoIcon);
  }, [user, userPref?.profileImage]);

  /* --------------------- data sector / agency ------------------------- */
  
  const [formattedSectors, setFormattedSectors] = useState([]);
  const [formattedAgencies, setFormattedAgencies] = useState([]);
  
  const { sectors, agencies } = useSelector((state) => state.Dashboard) // get sectors and agencies from store (Dashboard)
  
  useEffect(() => {
    dispatch(fetchDashboardRequest());
    dispatch(fetchProjectsRequest());
    dispatch(fetchUsersRequest());
    dispatch(checkConfigurationsExpiredRequest());
  }, []);
  
  useEffect(() => {
    if (sectors) {
      let newSectors = sectors.map((sector) => {
        return {
          id: sector.id,
          value: sector.id,
          label: sector.lib
        }
      });
      setFormattedSectors(newSectors);
    }
  }, [sectors]);

  useEffect(() => {
    if (agencies) {
      let newAgencies = agencies.map((agency) => {
        return {
          id: agency.id,
          value: agency.id,
          label: agency.lib
        }
      });
      setFormattedAgencies(newAgencies);
    }
  }, [agencies]);
  
  /* ---------------------------------------------- */  
  

  
  /* --------------------------------------- KPI FILTERS && CONFIGURATIONS --------------------------------------- */
  
    const activitiesData = useSelector((state) => state.Dashboard.activities)
    const configurationsData = useSelector((state) => state.Dashboard.configurations); // get configurations
    const quotesData = useSelector((state) => state.Dashboard.quotes); // get quotes

  /* ------------------------------------------------------------------------------ */  


  const [totalExpiredQuotes, setTotalExpiredQuotes] = useState(0); // total expired quotes

  useEffect(() => {
    if (quotesData && quotesData?.length > 0) {
      const totalExpiredQuotes = quotesData.reduce((sum, quote) => {
      const isExpired = quote.status === dictionary.projQuotes.statusExpired;
      return sum + (isExpired ? 1 : 0);
      }, 0);
      setTotalExpiredQuotes(totalExpiredQuotes);
    }
  }, [quotesData]);
    
  
  /* --------------------------------------- */  

  const [totalAveragePriceConfig, setTotalAveragePriceConfig] = useState(0); // total average price

  useEffect(() => {
    if (quotesData && quotesData?.length > 0) {
      const totalPrice = quotesData.reduce((sum, quote) => {
      return sum + quote.price;
      }, 0);
      
      const average = totalPrice / quotesData?.length;
      
      setTotalAveragePriceConfig(average.toFixed(2));
    } else {
      setTotalAveragePriceConfig(0);
    }
  }, [quotesData]);
  
  /* --------------------------------------- */  
  /* PIE -- Configuration by client type (activity)
    filter by date (month)

    labels [activities] -
    data => [list of % of configurations by activity]
  */
  const [monthSelected_chartConfigsByClientType, setMonthSelected_chartConfigsByClientType] = useState(dateNowMoment._d); // date picker state chartConfigsByClientType
  
  const handleChangeDate_chartConfigsByClientType = (date) => {
    setMonthSelected_chartConfigsByClientType(date);
  }
  
  const [labels_KPI_4_5, setLabels_KPI_4_5] = useState([]); // labels for KPI_6
  const [percentages_chartConfigsByClientType, setPercentages_chartConfigsByClientType] = useState([]); // percentages for chartConfigsByClientType
  const [percentages_chartConfigsByClientTypeFromStart, setPercentages_chartConfigsByClientTypeFromStart] = useState([]); // percentages for _chartConfigsByClientTypeFromStart

  useEffect( () => {  // chartConfigsByClientType data calculation
    setLabels_KPI_4_5(activitiesData.map(activity => t(activity)))

    let configurationsByActivity = {};

    for (let config in configurationsData) {

      // filter by date (month & year)
      const configDate = moment(configurationsData[config].date);
      const isSameDate = configDate.isSame(monthSelected_chartConfigsByClientType, 'month') && 
             configDate.isSame(monthSelected_chartConfigsByClientType, 'year');

      activitiesData.forEach(activity => {
        if (isSameDate) {
          if (configurationsData[config].activity === activity) {
            if (!configurationsByActivity[activity]) {
              configurationsByActivity[activity] = 0;
            }
            configurationsByActivity[activity]++;
          }
        } else {
          return
        }
      })
    }

    let totalConfigurations = Object.values(configurationsByActivity).reduce((acc, value) => acc + value, 0);
    
    let percentages = activitiesData.map(activity => {
        const count = configurationsByActivity[activity] || 0;
        return parseFloat(((count / totalConfigurations) * 100).toFixed(1));
    });
    
    if(totalConfigurations !== 0) {
      setPercentages_chartConfigsByClientType(percentages);
    } else {
      setPercentages_chartConfigsByClientType([])
    }
  }, [monthSelected_chartConfigsByClientType, activitiesData])


  useEffect( () => { // chartConfigsByClientTypeFromStart data calculation
    setLabels_KPI_4_5(activitiesData.map(activity => t(activity)))

    let configurationsByActivity = {};

    for (let config in configurationsData) {

      // filter by date (month & year)

      activitiesData.forEach(activity => {
          if (configurationsData[config].activity === activity) {
            if (!configurationsByActivity[activity]) {
              configurationsByActivity[activity] = 0;
            }
            configurationsByActivity[activity]++;
          }
      })
    }

    let totalConfigurations = Object.values(configurationsByActivity).reduce((acc, value) => acc + value, 0);
    
    let percentages = activitiesData.map(activity => {
        const count = configurationsByActivity[activity] || 0;
        return parseFloat(((count / totalConfigurations) * 100).toFixed(1));
    });
    
    if(totalConfigurations !== 0) {
      setPercentages_chartConfigsByClientTypeFromStart(percentages);
    } else {
      setPercentages_chartConfigsByClientTypeFromStart([])
    }
  }, [activitiesData])
  

  
  /* --------------------------------------- */
  /* PIE -- Configuration by sector
    filter by date (month) 

    labels [sectors] -
    data => [list of % of configurations by sector]
  */

  const [selectedFromDate_chartConfigsBySector, setSelectedFromDate_chartConfigsBySector] = useState(dateFromMoment._d); // selected from date for KPI_1
  const [selectedToDate_chartConfigsBySector, setSelectedToDate_chartConfigsBySector] = useState(dateNowMoment._d); // selected to date for KPI_1

  const [data_chartConfigsBySector, setData_chartConfigsBySector] = useState([]); // data for KPI_1
  const [labels_chartConfigsBySector, setLabels_chartConfigsBySector] = useState([]); // labels for KPI_1
  
  const handleChangeDate_chartConfigsBySector = (isFrom, date) => {
    if(isFrom) {
      setSelectedFromDate_chartConfigsBySector(date);
    } else {
      setSelectedToDate_chartConfigsBySector(date);
     }
  }

  useEffect( () => {  // chartConfigsByClientType data calculation
    setLabels_chartConfigsBySector(formattedSectors.map(sector => t(sector.label)))
    let configurationsBySector = {};

    for (let config in configurationsData) {
      const configDate = moment(configurationsData[config].date);
      const isSameDate = configDate.isAfter(selectedFromDate_chartConfigsBySector) && 
                         configDate.isBefore(selectedToDate_chartConfigsBySector);

      // filter by date (month & year)
      formattedSectors.forEach(sector => {
        if (isSameDate) {
          if (configurationsData[config].sectorId === sector.id) {
            if (!configurationsBySector[sector.label]) {
              configurationsBySector[sector.label] = (configurationsBySector[sector.label])?configurationsBySector[sector.label]:0;
            }
            configurationsBySector[sector.label]++;
          } else {
            configurationsBySector[sector.label] = (configurationsBySector[sector.label])?configurationsBySector[sector.label]:0;
          }
        } else {
          configurationsBySector[sector.label] = (configurationsBySector[sector.label])?configurationsBySector[sector.label]:0;
        }
      })
    }

    let configurationsBySectorValues = Object.values(configurationsBySector);
      
    if(configurationsBySectorValues) {
      setData_chartConfigsBySector(configurationsBySectorValues);
    } else {
      setData_chartConfigsBySector([])
    }

  }, [selectedFromDate_chartConfigsBySector, selectedToDate_chartConfigsBySector, formattedSectors])


  /* --------------------------------------- */
  /* Spine -- Evolution of the number of configurations
    filter by date range | from (month || year) to (month || year)
    filter by agency
    filter by sector

    y={
      [
        {
          name: "configurations",
          data: [NUMBER OF CONFIGURATIONS], 
        }
      ]
    }
    xaxis={
      [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }
      
    ||

    xaxis={
      [ "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013"]
    }
  */

  const [dateSelectedFrom_chartConfigEvolution, setdateSelectedFrom_chartConfigEvolution] = useState(dateFromMoment._d); // date picker state _chartConfigEvolution
  const [dateSelectedTo_chartConfigEvolution, setdateSelectedTo_chartConfigEvolution] = useState(dateNowMoment._d); // date picker state _chartConfigEvolution
  const [agencySelected_chartConfigEvolution, setAgencySelected_chartConfigEvolution] = useState([]); // agency selected state _chartConfigEvolution
  const [sectorSelected_chartConfigEvolution, setSectorSelected_chartConfigEvolution] = useState([]); // sector selected state _chartConfigEvolution
  const [isYearFiltered_chartConfigEvolution, setIsYearFiltered_chartConfigEvolution] = useState(false); // month / year filter state _chartConfigEvolution
  const [labels_chartConfigEvolution, setLabels_chartConfigEvolution] = useState([]); // labels for _chartConfigEvolution
  const [data_chartConfigEvolution, setData_chartConfigEvolution] = useState([]); // data for _chartConfigEvolution

  
  const handleChangeDateFrom_chartConfigEvolution = (date) => {
    setdateSelectedFrom_chartConfigEvolution(date);
  }
  const handleChangeDateTo_chartConfigEvolution = (date) => {
    setdateSelectedTo_chartConfigEvolution(date);
  }
  const handleYearMonthSwitch_chartConfigEvolution = () => {
    setIsYearFiltered_chartConfigEvolution(!isYearFiltered_chartConfigEvolution);
    setdateSelectedFrom_chartConfigEvolution(dateFromMoment._d);
    setdateSelectedTo_chartConfigEvolution(dateNowMoment._d);
  }

  useEffect(() => { // chartConfigEvolution data calculation
    // Remove the +1 to keep consistent 0-based month indexing throughout the code
    const selectedMonthFrom_chartConfigEvolution = moment(dateSelectedFrom_chartConfigEvolution).month();
    const selectedYearFrom_chartConfigEvolution = moment(dateSelectedFrom_chartConfigEvolution).year();

    const selectedMonthTo_chartConfigEvolution = moment(dateSelectedTo_chartConfigEvolution).month();
    const selectedYearTo_chartConfigEvolution = moment(dateSelectedTo_chartConfigEvolution).year();

    let configurationsByDate = [];
    let monthsNumbersArray = [];
    let yearsArray = [];

     if (isYearFiltered_chartConfigEvolution) { // get year range
       for (let year = selectedYearFrom_chartConfigEvolution; year <= selectedYearTo_chartConfigEvolution; year++) {
       yearsArray.push(year.toString());
       }
      setLabels_chartConfigEvolution(yearsArray);  
     } else { // get month range
      const monthsArray = [];
      
      // Keep month calculation consistent by using 0-based months throughout
      const startTotalMonths = (selectedYearFrom_chartConfigEvolution * 12) + selectedMonthFrom_chartConfigEvolution;
      const endTotalMonths = (selectedYearTo_chartConfigEvolution * 12) + selectedMonthTo_chartConfigEvolution;

        for (let totalMonths = startTotalMonths; totalMonths <= endTotalMonths; totalMonths++) {
          const year = Math.floor(totalMonths / 12);
          const month = totalMonths % 12;
          
          monthsArray.push(t(months[month]) + " " + year);
          monthsNumbersArray.push(`${month}-${year}`);
        }
        setLabels_chartConfigEvolution(monthsArray);
     }

    for (let config in configurationsData) { // filter by date (month & year)
      if (configurationsData[config].status === dictionary.projQuotes.statusQuoteOK || configurationsData[config].status === dictionary.projQuotes.statusPending) {
      if (isYearFiltered_chartConfigEvolution) {
        const configYear = moment(configurationsData[config].date).year();
        const isSameDate = configYear >= selectedYearFrom_chartConfigEvolution && configYear <= selectedYearTo_chartConfigEvolution; // range of years
        if (isSameDate) {
        configurationsByDate.push(configurationsData[config]);
        }
      } else {
        const configDate = moment(configurationsData[config].date);
        const startDate = moment(dateSelectedFrom_chartConfigEvolution).startOf('month');
        const endDate = moment(dateSelectedTo_chartConfigEvolution).endOf('month');
        
        const isSameDate = configDate.isBetween(startDate, endDate, null, '[]');
        if (isSameDate) {
        configurationsByDate.push(configurationsData[config]);
        }
      }
      }
    }
    
    if (sectorSelected_chartConfigEvolution?.length > 0 || agencySelected_chartConfigEvolution?.length > 0) { // filter by agency and sector
      let filteredConfigs = [...configurationsByDate];
      
      // Filter by sector if selected
      if (sectorSelected_chartConfigEvolution?.length > 0) {
      filteredConfigs = filteredConfigs.filter(config => 
        sectorSelected_chartConfigEvolution.includes(config.sectorId)
      );
      }
      
      // Filter by agency if selected
      if (agencySelected_chartConfigEvolution?.length > 0) {
      filteredConfigs = filteredConfigs.filter(config => 
        agencySelected_chartConfigEvolution.includes(config.agencyId)
      );
      }
      
      configurationsByDate = filteredConfigs;
    }
    
    const formatDataToDateOrder = (configs) => { 
      const dateCounts = {};
      
      configs.forEach(config => {
        const configDate = moment(config.date);
        const year = configDate.year();
        const month = configDate.month() ;

        const dateKey = isYearFiltered_chartConfigEvolution ? year.toString() : month + '-' + year;;

        if (!dateCounts[dateKey]) {
          dateCounts[dateKey] = 0;
        }
        dateCounts[dateKey]++;
      })

      if (isYearFiltered_chartConfigEvolution) {
      const sortedDataByYear = yearsArray.map(year => dateCounts[year] || 0);
      setData_chartConfigEvolution(sortedDataByYear);
      } else {
      const sortedData = monthsNumbersArray.map(monthYear => dateCounts[monthYear] || 0);
      setData_chartConfigEvolution(sortedData);
      }
    }

    formatDataToDateOrder(configurationsByDate);

    }, [dateSelectedFrom_chartConfigEvolution, dateSelectedTo_chartConfigEvolution, agencySelected_chartConfigEvolution, sectorSelected_chartConfigEvolution, isYearFiltered_chartConfigEvolution, configurationsData]);

  /* --------------------------------------- */
  /* ColumnWithDataLabels -- Quotes prices
    filter by date range | from (month || year) to (month || year)
    filter by agency
    filter by sector

    series={[
          {
            name: t('facturedQuotesDONE'), "le premier jeu de données montre le montant des devis validés au cours de la période en cours (mois ou année)"
            data: [101, 1511, 8, 12, 17, 14, 20, 22, 25, 30, 28, 35]
            },
            {
              name: t('facturedQuotesEXPIRED') "le second jeu de données montre le montant des devis terminés (plus valides) au cours de la période en cours (mois ou année)",
            data: [35, 28, 30, 25, 22, 20, 14, 17, 12, 8, 15, 10]
          },
        ]}
    xaxisConfig={
      {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      }
    }

    ||

    xaxisConfig={
      categories: [ "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013"]
    }
  */
  
  const [dateSelectedFrom_chartTotalFactured, setdateSelectedFrom_chartTotalFactured] = useState(dateFromMoment._d); // date picker state chartTotalFactured
  const [dateSelectedTo_chartTotalFactured, setdateSelectedTo_chartTotalFactured] = useState(dateNowMoment._d); // date picker state chartTotalFactured
  const [agencySelected_chartTotalFactured, setAgencySelected_chartTotalFactured] = useState([]); // agency selected state chartTotalFactured
  const [sectorSelected_chartTotalFactured, setSectorSelected_chartTotalFactured] = useState([]); // sector selected state chartTotalFactured

  const [isYearFiltered_chartTotalFactured, setIsYearFiltered_chartTotalFactured] = useState(false); // month / year filter state chartTotalFactured

  const [labels_chartTotalFactured, setLabels_chartTotalFactured] = useState([]); // labels for chartTotalFactured
  const [dataDone_chartTotalFactured, setDataDone_chartTotalFactured] = useState([]); // data for chartTotalFactured
  const [dataExpired_chartTotalFactured, setDataExpired_chartTotalFactured] = useState([]); // data for chartTotalFactured

  const [dataDoneCumuled_chartTotalFactured, setdataDoneCumuled_chartTotalFactured_chartTotalFactured] = useState([]); // data for chartTotalFactured cumuled ( line chart )
  
  const handleChangeDateFrom_chartTotalFactured = (date) => {
    setdateSelectedFrom_chartTotalFactured(date);
  }
  const handleChangeDateTo_chartTotalFactured = (date) => {
    setdateSelectedTo_chartTotalFactured(date);
  }
  const handleYearMonthSwitch_chartTotalFactured = () => {
    setIsYearFiltered_chartTotalFactured(!isYearFiltered_chartTotalFactured);
    setdateSelectedFrom_chartTotalFactured(dateFromMoment._d);
    setdateSelectedTo_chartTotalFactured(dateNowMoment._d);
  }


    useEffect(() => { // chartTotalFactured data calculation
    const selectedMonthFrom_chartTotalFactured = moment(dateSelectedFrom_chartTotalFactured).month();
    const selectedYearFrom_chartTotalFactured = moment(dateSelectedFrom_chartTotalFactured).year();

    const selectedMonthTo_chartTotalFactured = moment(dateSelectedTo_chartTotalFactured).month();
    const selectedYearTo_chartTotalFactured = moment(dateSelectedTo_chartTotalFactured).year();

    const quotesBySectorsAndAgencies = quotesData.filter(quote => {
        const isSameSector = sectorSelected_chartTotalFactured.length ? sectorSelected_chartTotalFactured.includes(quote.sectorId) : true;
        const isSameAgency = agencySelected_chartTotalFactured.length ? agencySelected_chartTotalFactured.includes(quote.agencyId) : true;
        
        return isSameSector && isSameAgency;
      });
    
    let quotesByDateExpired = {};
    let quotesByDateDone = {};
    let quotesByDateCumuled = {}; // for cumuled data
    let monthsNumbersArray = [];
    let yearsArray = [];

     if (isYearFiltered_chartTotalFactured) { // get year range
       for (let year = selectedYearFrom_chartTotalFactured; year <= selectedYearTo_chartTotalFactured; year++) {
         yearsArray.push(year.toString());
       }
        setLabels_chartTotalFactured(yearsArray);  
     } else { // get month range
        const monthsArray = [];

        const startTotalMonths = selectedYearFrom_chartTotalFactured * 12 + selectedMonthFrom_chartTotalFactured;
        const endTotalMonths = selectedYearTo_chartTotalFactured * 12 + selectedMonthTo_chartTotalFactured;

        // Generate sequence of months from start to end
        for (let totalMonths = startTotalMonths; totalMonths <= endTotalMonths; totalMonths++) {
          const year = Math.floor(totalMonths / 12);
          const month = totalMonths % 12;
          
          monthsArray.push(t(months[month]) + " " + year);
          monthsNumbersArray.push(`${month}-${year}`);
        }

        setLabels_chartTotalFactured(monthsArray);
     }


     for (let quote in quotesBySectorsAndAgencies) { // filter by date (month & year)
      if (isYearFiltered_chartTotalFactured) { // filter by year
        const quoteYear = moment(quotesData[quote].date).year();
        const isSameDate = quoteYear >= selectedYearFrom_chartTotalFactured && quoteYear <= selectedYearTo_chartTotalFactured; // range of years

        if (isSameDate) {
          if (quotesData[quote].status === dictionary.projQuotes.statusExpired) { // expired quotes
            const quoteYear = moment(quotesData[quote].date).year();
            const dateKey = quoteYear.toString();

            if (!quotesByDateExpired[dateKey]) {
              quotesByDateExpired[dateKey] = 0;
            }
            quotesByDateExpired[dateKey] += quotesData[quote].price;
          } else if (quotesData[quote].status === dictionary.projQuotes.statusQuoteOK) { // statusQuoteOK quotes
            const quoteYear = moment(quotesData[quote].date).year();
            const dateKey = quoteYear.toString();

            if (!quotesByDateDone[dateKey]) {
              quotesByDateDone[dateKey] = 0;
            }
            quotesByDateDone[dateKey] += quotesData[quote].price;

            // For cumulative calculation in year mode
            if (!quotesByDateCumuled[dateKey]) {
              quotesByDateCumuled[dateKey] = quotesData[quote].price;
            } else {
              quotesByDateCumuled[dateKey] += quotesData[quote].price;
            }

            // If there's a previous year's cumulative value, add it to current year
            if (isYearFiltered_chartTotalFactured) {
              const quoteYear = moment(quotesData[quote].date).year();
              const previousYear = quoteYear - 1;
              const previousYearKey = previousYear.toString();

              if (quotesByDateCumuled[previousYearKey]) {
              quotesByDateCumuled[dateKey] += quotesByDateCumuled[previousYearKey];
              }
            }
          }
        }

      } else { // filter by month
        const quoteDate = moment(quotesData[quote].date);
        const startDate = moment(dateSelectedFrom_chartTotalFactured).startOf('month');
        const endDate = moment(dateSelectedTo_chartTotalFactured).endOf('month');

        const isSameDate = quoteDate.isBetween(startDate, endDate, null, '[]');
        if (isSameDate) {

          if (quotesData[quote].status === dictionary.projQuotes.statusExpired) { // expired quotes
            const quoteDate = moment(quotesData[quote].date);
            const quoteMonth = quoteDate.month();
            const quoteYear = quoteDate.year();
            
            const dateKey = isYearFiltered_chartTotalFactured ? quoteYear.toString() : quoteMonth + '-' + quoteYear;
            
            if (!quotesByDateExpired[dateKey]) {
              quotesByDateExpired[dateKey] = 0;
            }
            quotesByDateExpired[dateKey] += quotesData[quote].price;
          } else if (quotesData[quote].status === dictionary.projQuotes.statusQuoteOK) { // statusQuoteOK quotes
            const quoteDate = moment(quotesData[quote].date);
            const quoteMonth = quoteDate.month();
            const quoteYear = quoteDate.year();
            
            const dateKey = isYearFiltered_chartTotalFactured ? quoteYear.toString() : quoteMonth + '-' + quoteYear;
            
            if (!quotesByDateDone[dateKey]) {
              quotesByDateDone[dateKey] = 0;
            }
            quotesByDateDone[dateKey] += quotesData[quote].price;

            if (!quotesByDateCumuled[dateKey]) {
              quotesByDateCumuled[dateKey] = quotesData[quote].price;
            } else {
              quotesByDateCumuled[dateKey] += quotesData[quote].price;
            }

          }
        }
      }
    }

    const formatDataToDateOrder = () => { // format data to date order

      if (isYearFiltered_chartTotalFactured) {
        const expiredData = yearsArray.map(year => parseFloat(quotesByDateExpired[year] || 0).toFixed(2));
        const doneData = yearsArray.map(year => parseFloat(quotesByDateDone[year] || 0).toFixed(2));
        const doneCumuledData = yearsArray.map(year => {
          let runningTotal = 0;
          
          return yearsArray.map((y, index) => {
            // Add current year's value to the running total
            if (yearsArray.indexOf(y) <= yearsArray.indexOf(year)) {
              const currentYearValue = parseFloat(quotesByDateDone[y] || 0);
              runningTotal += currentYearValue;
            }
            
            return runningTotal.toFixed(2);
          })[yearsArray.indexOf(year)];
        });
        
        setDataExpired_chartTotalFactured(expiredData);
        setDataDone_chartTotalFactured(doneData);
        setdataDoneCumuled_chartTotalFactured_chartTotalFactured(doneCumuledData);
        } else {
        const expiredData = monthsNumbersArray.map(monthYear => {
          return parseFloat(quotesByDateExpired[monthYear] || 0).toFixed(2);
        });
        
        const doneData = monthsNumbersArray.map(monthYear => {
          return parseFloat(quotesByDateDone[monthYear] || 0).toFixed(2);
        });

        const doneCumuledData = monthsNumbersArray.map(monthYear => {
            let runningTotal = 0;
            
            return monthsNumbersArray.map((month, index) => {
              // Add current month's value to the running total
              const currentMonthValue = parseFloat(quotesByDateDone[month] || 0);
              runningTotal += currentMonthValue;
              
              return runningTotal.toFixed(2);
            })[monthsNumbersArray.indexOf(monthYear)];
        });
        
        setDataExpired_chartTotalFactured(expiredData);
        setDataDone_chartTotalFactured(doneData);
        setdataDoneCumuled_chartTotalFactured_chartTotalFactured(doneCumuledData);
        }
    }

    
    formatDataToDateOrder();


  }, [dateSelectedFrom_chartTotalFactured, dateSelectedTo_chartTotalFactured, agencySelected_chartTotalFactured, sectorSelected_chartTotalFactured, isYearFiltered_chartTotalFactured, quotesData]);


  /* --------------------------------------- */

/* ---------------------------------------------------------------- ---------------------------------------------------------------- */
  
  
  const SideBar = () => {
    
    return ( /* sub-component dashboard (sidebar) */
      <div className="sidebar">
        <div className='profileContainer'>
        <div className='card pc-user-card'>
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="profileImg">

                  {imgSrc ? <img src={imgSrc} alt="user-image" className="user-avatar rounded-circle" /> : <Loading  type={'large'}/>}

              </div>
              <div className="flex-grow-1 ms-1">
                <span>{t('welcomeBack')} 👋</span>
                <Link to={'/profile'}>
                  <h6 className="mb-0">{user?.fullName}</h6>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sidebarContent">
            <div className="card">
              <div className="card-body p-3">
                <div className="dataContainer">
                  <p className="dataTitle"> <i className="mdi mdi-account-group-outline" /> {t('customers')}</p>
                  <span className="infoData">{customersNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle"> <i className="mdi mdi-file-document-multiple-outline" /> {t('myProjects')}</p>
                  <span className="infoData">{projectsNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-package-variant color-inProgress" /> {t('myProjectsOpen')}</p>
                  <span className="infoData">{projectsOpen}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-package-variant-closed color-expired" /> {t('myProjectsClosed')}</p>
                  <span className="infoData">{projectsClose}</span>
                </div>
                <hr />
                <div className="dataContainer">
                  <p className="dataTitle"> <i className="mdi mdi-file-cog-outline" /> {t('Configurations')}</p>
                  <span className="infoData">{configsNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-file-clock-outline color-inProgress" /> {t('PENDING')} </p>
                  <span className="infoData">{inProgressConfigNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-file-check-outline color-confirmed" /> {t('QUOTE_OK')} </p>
                  <span className="infoData">{confirmedConfigNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-file-alert-outline color-expired" /> {t('EXPIRED')} </p>
                  <span className="infoData">{expiredConfigNum}</span>
                </div>
              </div>

            </div>

              <div className="card-body helpCard">

              <div className="dataContainer">
                <p className="dataTitle subTitle" onClick={() => window.open("https://www.cenco.fr/#catalogue-cenco-2024/1/", "_blank")}> <i className="mdi mdi-book-outline" /> <span className="helpLink">{t('ask')} {t('catalog')}</span> </p>
              </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle" onClick={() => window.open("https://www.cenco.fr/contact-et-acces/", "_blank")}> <i className="mdi mdi-file-document-edit-outline" /> <span className="helpLink">{t('ask')} {t('estimateAndInfo')} </span> </p>
              </div>

              </div>

            <div className="card-body contactCard">

                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-map-marker" /> 36 rue de l'Industrie,<br /> 01540 VONNAS </p>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-phone" /> 04 74 42 53 74 </p>
                </div>


            </div>
        </div>
</div>
)}



return (
  <div className="page-content">
      <DashboardLayout containerClass="dashboardContainer" sideBar={<SideBar />}>
        <Card className="w-100 dashboardCard">
          <Col xl={12} className="dashboardContent">

          <Row>
            {/* ----------------- kpiExpiredQuotes ----------------- */}
              <TotalKpi
                key={"kpiExpiredQuotes"}
                label={"kpiExpiredQuotes"}
                disposition={"col-12 col-md-6 col-xl-6"}
                iconClass={"mdi mdi-book-alert-outline"}
                description={totalExpiredQuotes}
                />
            {/* ----------------- kpiAveragePrice ----------------- */}
              <TotalKpi
                key={"kpiAveragePrice"}
                label={"kpiAveragePrice"}
                disposition={"col-12 col-md-6 col-xl-6"}
                iconClass={"mdi mdi-sack-percent"}
                description={"€ " + totalAveragePriceConfig}
                />
            {/* ----------------- KPI ----------------- */}
          </Row>

          <Row>
            <Col xl="6" className="d-flex flex-column">
            {/* ----------------- chartConfigsByClientType ----------------- */}
              <Card className="flex-fill">
                <CardBody>
                <CardTitle className="mb-4 d-flex justify-content-between text-align-start">{`${t('chartConfigsByClientType')}`}

                  <div className="w-50 m-0 d-flex justify-content-end align-items-end datePickerContainer">

                    <DatePicker
                      dateFormat="MMMM yyyy"
                      showMonthYearPicker
                      className="dataPicker-input"
                      selected={monthSelected_chartConfigsByClientType}
                      locale="fr"
                      onChange={handleChangeDate_chartConfigsByClientType}
                    />

                  </div>
                  </CardTitle>
                  {
                    loadingDashboard ? (
                      <div className="w-100 m-0 d-flex justify-content-center align-items-center">
                        <Spinner size="sm" className="me-2" />
                      </div>
                    )
                    :
                    percentages_chartConfigsByClientType?.length ? (
                      <PieChart 
                        labels={labels_KPI_4_5}
                        data={percentages_chartConfigsByClientType}
                        colors={chartColorsPallette}
                        isPercentage={true}
                      />
                    ) : (
                      <div className="w-100 h-75 m-0 d-flex justify-content-center align-items-center">
                        <p className="fs-5">{t('noDataAvailable')}</p>
                      </div>
                    )
                  }
                </CardBody>
              </Card>
            {/* ----------------- /KPI ----------------- */}
            </Col>
            <Col xl="6" className="d-flex flex-column">
            {/* ----------------- chartConfigsByClientTypeFromStart ----------------- */}
              <Card className="flex-fill">
                <CardBody>
                <CardTitle className="mb-5">{`${t('chartConfigsByClientTypeStart')}`} </CardTitle>
                {
                  loadingDashboard ? (
                    <div className="w-100 m-0 d-flex justify-content-center align-items-center">
                      <Spinner size="sm" className="me-2" />
                    </div>
                  )
                  :
                  percentages_chartConfigsByClientTypeFromStart?.length ? (
                    <PieChart 
                    labels={labels_KPI_4_5} 
                    data={percentages_chartConfigsByClientTypeFromStart} 
                    colors={chartColorsPallette}
                    isPercentage={true}
                    />
                  ) : (
                    <div className="w-100 h-75 m-0 d-flex justify-content-center align-items-center">
                      <p className="fs-5">{t('noDataAvailable')}</p>
                    </div>
                  )
                }
                </CardBody>
              </Card>
            {/* ----------------- /KPI ----------------- */}
            </Col>
          </Row>

          <Row>
            <Col xl="6" className="d-flex flex-column">
                {/* ----------------- chartNumberConfigBySector ----------------- */}
                  <Card className="flex-fill">
                    <CardBody>
                    <CardTitle className="mb-4 d-flex justify-content-between text-align-start">{`${t('chartNumberConfigBySector')}`}
                      <div className="w-50 m-0 d-flex justify-content-end align-items-end datePickerContainer">
                          <p className="m-2">{t('from')}</p>
                          <DatePicker
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            className="dataPicker-input mb-1"
                            selected={selectedFromDate_chartConfigsBySector}
                            locale="fr"
                            onChange={(date) => handleChangeDate_chartConfigsBySector(true, date)}
                            maxDate={new Date(new Date().getFullYear(), 11, 31)}
                            />
                          <p className="m-2">{t('toMonth')}</p>
                          <DatePicker
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            className="dataPicker-input mb-1"
                            selected={selectedToDate_chartConfigsBySector}
                            locale="fr"
                            onChange={(date) => handleChangeDate_chartConfigsBySector(false, date)}
                            maxDate={new Date(new Date().getFullYear(), 11, 31)}
                          />
                      </div>
                    </CardTitle>
                      {
                        loadingDashboard ? (
                          <div className="w-100 m-0 d-flex justify-content-center align-items-center">
                            <Spinner size="sm" className="me-2" />
                          </div>
                        )
                        :
                        data_chartConfigsBySector?.length ? (
                          <PieChart 
                          labels={labels_chartConfigsBySector} 
                          data={data_chartConfigsBySector} 
                          colors={chartColorsPallette}
                          />
                        ) : (
                          <div className="w-100 h-75 m-0 d-flex justify-content-center align-items-center">
                            <p className="fs-5">{t('noDataAvailable')}</p>
                          </div>
                        )
                      }
                    </CardBody>
                  </Card>
                {/* ----------------- /KPI ----------------- */}
              </Col>
              <Col xl="6" className="d-flex flex-column">
              {/* ----------------- chartConfigEvolution ----------------- */}
                <Card className="flex-fill">
                  <CardBody>
                    <CardTitle className="mb-4">{`${t('chartDevNumberConfig')}`}</CardTitle>
                      <div className="w-100 m-0 d-flex justify-content-center align-items-center">

                        { isYearFiltered_chartConfigEvolution ? (
                          <>
                          <p className="m-2">{t('from')}</p>
                          <DatePicker
                            dateFormat="yyyy"
                            showYearPicker
                            className="dataPicker-input mb-1"
                            selected={dateSelectedFrom_chartConfigEvolution}
                            locale="fr"
                            onChange={handleChangeDateFrom_chartConfigEvolution}
                            maxDate={new Date(new Date().getFullYear(), 11, 31)}
                            />
                          <p className="m-2">{t('toMonth')}</p>
                          <DatePicker
                            dateFormat="yyyy"
                            showYearPicker
                            className="dataPicker-input mb-1"
                            selected={dateSelectedTo_chartConfigEvolution}
                            locale="fr"
                            onChange={handleChangeDateTo_chartConfigEvolution}
                            maxDate={new Date(new Date().getFullYear(), 11, 31)}
                          />
                          </>
                          ) : (
                          <>
                          <p className="m-2">{t('from')}</p>
                          <DatePicker
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            className="dataPicker-input mb-1"
                            selected={dateSelectedFrom_chartConfigEvolution}
                            locale="fr"
                            onChange={handleChangeDateFrom_chartConfigEvolution}
                            />
                          <p className="m-2">{t('toMonth')}</p>
                          <DatePicker
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            className="dataPicker-input mb-1"
                            selected={dateSelectedTo_chartConfigEvolution}
                            locale="fr"
                            onChange={handleChangeDateTo_chartConfigEvolution}
                            />
                          </>
                        )
                        }

                      </div>
                      <div className="w-100 mt-3 d-flex justify-content-between align-items-center">
                        <Select
                          isMulti={true}
                          isClearable={true}
                          name={"selectedAgencies_chartConfigEvolution"}
                          id={"selectedAgencies_chartConfigEvolution"}
                          placeholder={t('agencies')}
                          value={formattedAgencies.filter(option => (agencySelected_chartConfigEvolution || []).includes(option.value))}
                          onChange={selected => {
                            const selectedValues = selected ? selected.map(option => option.value) : [];
                            
                            setAgencySelected_chartConfigEvolution(selectedValues);
                          }}
                          options={formattedAgencies}
                          classNamePrefix="react-select"
                          className={"react-select-container w-100 mx-1"}
                          formatGroupLabel={(data) => (
                            <div className='selectGrouped-TitleGroup'>
                              <span>{data.label}</span>
                            </div>
                          )}
                          data-cy={'form-input-' + "selectedAgencies_chartConfigEvolution"}
                        />
                        <Select
                          isMulti={true}
                          isClearable={true}
                          name={"selectedSectors_chartConfigEvolution"}
                          id={"selectedSectors_chartConfigEvolution"}
                          placeholder={t('sectors')}
                          options={formattedSectors}
                          value={formattedSectors.filter(option => (sectorSelected_chartConfigEvolution || []).includes(option.value))}
                          onChange={selected => {
                            const selectedValues = selected ? selected.map(option => option.value) : [];
                            
                            setSectorSelected_chartConfigEvolution(selectedValues);
                          }}
                          classNamePrefix="react-select"
                          className={"react-select-container w-100 mx-1"}
                          formatGroupLabel={(data) => (
                            <div className='selectGrouped-TitleGroup'>
                              <span>{data.label}</span>
                            </div>
                          )}
                          data-cy={'form-input-' + "selectedSectors_chartConfigEvolution"}
                          />
                        </div>
                        {
                          loadingDashboard ? (
                            <div className="w-100 m-0 d-flex justify-content-center align-items-center">
                              <Spinner size="sm" className="me-2" />
                            </div>
                          )
                          :
                          data_chartConfigEvolution?.length ? (
                            <SpineChart
                                y={
                                  [
                                    {
                                      name: t('numberOfConfigurations'),
                                      data: data_chartConfigEvolution,
                                    }
                                  ]
                                }
                                xaxis={
                                  labels_chartConfigEvolution
                                }
                              />
                          ) : (
                            <div className="w-100 h-75 m-0 d-flex justify-content-center align-items-center">
                              <p className="fs-5">{t('noDataAvailable')}</p>
                            </div>
                          )
                        }
                      <div className="w-100 m-0 d-flex justify-content-center align-items-center">
                          <p className="me-2">{t('month')}</p>
                          
                          <FormGroup switch className="switchContainer" id={'projDashboardFilterMonthYearSwitch_chartConfigEvolution'}>
                            <Input
                            type="switch"
                            checked={isYearFiltered_chartConfigEvolution}
                            onChange={() => {handleYearMonthSwitch_chartConfigEvolution()}}
                            />
                          </FormGroup>
                          <UncontrolledTooltip
                              transition={{ timeout: 300 }}
                              placement="top"
                              fade={false}
                              target={"projDashboardFilterMonthYearSwitch_chartConfigEvolution"}
                              >
                              {t('chosenFilter') + " : " + (isYearFiltered_chartConfigEvolution ? t('year') : t('month'))}
                          </UncontrolledTooltip>
                          
                          <p className="ms-2">{t('year')}</p> 
  
                      </div>
                  </CardBody>
                </Card>
              {/* ----------------- /KPI ----------------- */}
              </Col>
            </Row>

            <Row>
              <Col xl="12" className="d-flex flex-column">
              {/* ----------------- chartTotalFactured ----------------- */}
                <Card className="flex-fill">
                  <CardBody>
                    <CardTitle className="mb-4">{`${t('chartTotalFactured')}`}</CardTitle>
                      <div className="w-100 m-0 d-flex justify-content-center align-items-center">
                        
                        { isYearFiltered_chartTotalFactured ? (
                          <>
                          <p className="m-2">{t('from')}</p>
                          <DatePicker
                            dateFormat="yyyy"
                            showYearPicker
                            className="dataPicker-input mb-1"
                            selected={dateSelectedFrom_chartTotalFactured}
                            locale="fr"
                            onChange={handleChangeDateFrom_chartTotalFactured}
                            maxDate={new Date(new Date().getFullYear(), 11, 31)}
                            />
                          <p className="m-2">{t('toMonth')}</p>
                          <DatePicker
                            dateFormat="yyyy"
                            showYearPicker
                            className="dataPicker-input mb-1"
                            selected={dateSelectedTo_chartTotalFactured}
                            locale="fr"
                            onChange={handleChangeDateTo_chartTotalFactured}
                            maxDate={new Date(new Date().getFullYear(), 11, 31)}
                          />
                          </>
                          ) : (
                          <>
                          <p className="m-2">{t('from')}</p>
                          <DatePicker
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            className="dataPicker-input mb-1"
                            selected={dateSelectedFrom_chartTotalFactured}
                            locale="fr"
                            onChange={handleChangeDateFrom_chartTotalFactured}
                            />
                          <p className="m-2">{t('toMonth')}</p>
                          <DatePicker
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            className="dataPicker-input mb-1"
                            selected={dateSelectedTo_chartTotalFactured}
                            locale="fr"
                            onChange={handleChangeDateTo_chartTotalFactured}
                            />
                          </>
                        )
                        }

                      </div>
                      <div className="w-100 mt-3 d-flex justify-content-between align-items-center">
                      <Select
                          isMulti={true}
                          isClearable={true}
                          name={"selectedAgencies_chartTotalFactured"}
                          id={"selectedAgencies_chartTotalFactured"}
                          placeholder={t('agencies')}
                          value={formattedAgencies.filter(option => (agencySelected_chartTotalFactured || []).includes(option.value))}
                          onChange={selected => {
                            const selectedValues = selected ? selected.map(option => option.value) : [];
                            
                            setAgencySelected_chartTotalFactured(selectedValues);
                          }}
                          options={formattedAgencies}
                          classNamePrefix="react-select"
                          className={"react-select-container w-100 mx-1"}
                          formatGroupLabel={(data) => (
                            <div className='selectGrouped-TitleGroup'>
                              <span>{data.label}</span>
                            </div>
                          )}
                          data-cy={'form-input-' + "selectedAgencies_chartTotalFactured"}
                        />
                        <Select
                          isMulti={true}
                          isClearable={true}
                          name={"selectedSectors_chartTotalFactured"}
                          id={"selectedSectors_chartTotalFactured"}
                          placeholder={t('sectors')}
                          options={formattedSectors}
                          value={formattedSectors.filter(option => (sectorSelected_chartTotalFactured || []).includes(option.value))}
                          onChange={selected => {
                            const selectedValues = selected ? selected.map(option => option.value) : [];
                            
                            setSectorSelected_chartTotalFactured(selectedValues);
                          }}
                          classNamePrefix="react-select"
                          className={"react-select-container w-100 mx-1"}
                          formatGroupLabel={(data) => (
                            <div className='selectGrouped-TitleGroup'>
                              <span>{data.label}</span>
                            </div>
                          )}
                          data-cy={'form-input-' + "selectedSectors_chartTotalFactured"}
                          />
                        </div>
                        <SpineAndColumnChart
                            series={[
                                  {
                                    name: t('facturedQuotesDONE'),
                                    data: dataDone_chartTotalFactured,
                                    type: 'column'
                                  },
                                  {
                                    name: t('facturedQuotesEXPIRED'),
                                    data: dataExpired_chartTotalFactured,
                                    type: 'column'
                                  },
                                  {
                                    name: t('facturedQuotesDONE'),
                                    data: dataDoneCumuled_chartTotalFactured,
                                    type: 'line'
                                  }
                                ]}
                              xaxisConfig={
                              {
                              categories: labels_chartTotalFactured
                              }
                            }
                          />
                      <div className="w-100 m-0 d-flex justify-content-center align-items-center">
                          <p className="me-2">{t('month')}</p>
                          
                          <FormGroup switch className="switchContainer" id={"projDashboardFilterMonthYearSwitch_chartTotalFactured"}>
                            <Input
                              type="switch"
                              checked={isYearFiltered_chartTotalFactured}
                              onChange={() => {handleYearMonthSwitch_chartTotalFactured()}}
                            />
                          </FormGroup>
                          <UncontrolledTooltip
                              transition={{ timeout: 300 }}
                              placement="top"
                              fade={false}
                              target={"projDashboardFilterMonthYearSwitch_chartTotalFactured"}
                              >
                              {t('chosenFilter') + " : " + (isYearFiltered_chartTotalFactured ? t('year') : t('month'))}
                          </UncontrolledTooltip>
                          
                          <p className="ms-2">{t('year')}</p> 
  
                      </div>
                  </CardBody>
                </Card>
              {/* ----------------- /KPI ----------------- */}
              </Col>

            </Row>

          </Col>
        </Card>
      </DashboardLayout>
        <ToastContainer />
    </div>
  )
}